import {inject, Injectable} from '@angular/core';
import {MatDialog} from "@angular/material/dialog";
import {CloseModalReason} from "../../../../core/types/modal.types";
import {
  TelegramVideoModalComponent
} from "../components/modals/telegram-video-modal/telegram-video-modal.component";
import {
  TelegramUpdateAccountPhotoModalComponent
} from "../components/modals/telegram-update-account-photo-modal/telegram-update-account-photo-modal.component";
import {RecordTableApiService} from "../../../../core/services-api/record-table-api.service";
import {LoadImageParams, UserChatQueryParams} from "../types/telegram-page.types";
import {
  TelegramSaveFileModalComponent
} from "../components/modals/telegram-save-file-modal/telegram-save-file-modal.component";
import {TelegramApiService} from "./telegram-api.service";
import {SaveFileParams} from "../types/telegram-save-file-modal.types";
import {
  TelegramImageModalComponent
} from "../components/modals/telegram-image-modal/telegram-image-modal.component";

@Injectable({
  providedIn: 'root'
})
export class TelegramModalsService {
  private dialog: MatDialog = inject(MatDialog);
  private recordTableApiService: RecordTableApiService = inject(RecordTableApiService);
  private telegramApiService: TelegramApiService = inject(TelegramApiService);

  public openTelegramVideoModal(loadImageParams: LoadImageParams): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramVideoModalComponent, {
      data: loadImageParams,
      width: '800px'
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => {
        resolve(reason);
      });
    });
  }

  public openTelegramImageModal(url: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramImageModalComponent, {
      data: { url },
      width: '800px'
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => {
        resolve(reason);
      });
    });
  }

  public openTelegramUpdateAccountPhotoModal(accountId: string): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramUpdateAccountPhotoModalComponent, {
      data: { accountId },
      width: '400px'
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => {
        resolve(reason);
      });
    });
  }

  public getTelegramChat(id: number): Promise<UserChatQueryParams> {
    return new Promise((resolve, reject) => {
      this.recordTableApiService.getTelegramChat(id).subscribe({
        next: (userChatQueryParams: UserChatQueryParams) => resolve(userChatQueryParams),
        error: (error) => reject(error)
      })
    });
  }

  public openSaveFileToSThree(messageId: number): Promise<CloseModalReason> | void {
    const dialogRef = this.dialog.open(TelegramSaveFileModalComponent, {
      data: {
        messageId: messageId
      }
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((reason: CloseModalReason) => {
        resolve(reason);
      });
    });
  }

  public saveFile(saveFileParams: SaveFileParams): Promise<void> {
    return new Promise((resolve, reject) => {
      this.telegramApiService.saveFile(saveFileParams).subscribe({
        next: () => resolve(),
        error: (error) => reject(error)
      });
    });
  }
}
